import styles from './Intro.module.css'
import { Slice } from '@prismicio/types'
import { SliceType } from '../../const'

export type IntroProps = Slice<SliceType.intro>

export function Intro(): string {
	return /* HTML */ ` <div class="${styles.Main}"></div> `
}
